import angular from 'angular'
import template from './template.html'

angular.module('nominas.catalogos')
  .component('nominasCatalogosConceptosConcepto', {
    template: template,
    controller: NominasCatalogosConceptosConceptoComponent,
    bindings: {
      concepto: '<',
      onClose: '&',
    },
  });

function NominasCatalogosConceptosConceptoComponent($http) {
  let $ctrl = this;

  $ctrl.$onInit = $onInit;
  $ctrl.aceptar = aceptar;
  $ctrl.cerrar = cerrar;

  function $onInit() {
    $ctrl.promise = $http.get('api/nominas/catalogos/conceptos/concepto', {
        params: {id: $ctrl.concepto.id},
        schema: NominasCatalogosConceptosConceptoSchema,
      })
      .then(function (response) {
        $ctrl.data = response.data;
      });
  }

  function aceptar() {
    $ctrl.onClose({$event: {data: $ctrl.data}});
  }

  function cerrar(dirty) {
    if (dirty) {
      return;
    }

    $ctrl.onClose({$event: {}});
  }
}

let NominasCatalogosConceptosConceptoSchema = {
  activo: 'boolean',
  editar_dias: 'boolean',
  editar_horas: 'boolean',
  editar_importe: 'boolean',
  id: 'number',
  impuesto_estatal: 'boolean',
  orden: 'number',
};



// WEBPACK FOOTER //
// ./src/nominas/catalogos/components/conceptos/concepto/controller.js